import './styles/data-system-details.scss'

import React       from 'react'
import PropTypes   from 'prop-types'

import DeliveryConfigListItem from '../deliveryConfig/DeliveryConfigListItem'
import ScrollableItemList     from '../components/ScrollableItemList'
import DetailsHeader          from '../components/DetailsHeader'
import Loading                from '../components/Loading'

import api from '../redux/api'

const DELIVERY_CONFIG_PAGE_COUNT = 10

export default class DataSystemDetails extends React.Component {
  static propTypes = {
    match:   PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  state = {
    data: null,
  }

  constructor(props) {
    super(props)
    this.handlePropChange(props)
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.handlePropChange(props)
  }

  handlePropChange(props) {
    const { data } = this.state

    if (!data || props.match.params.id !== this.props.match.params.id) {
      const { id } = props.match.params

      api.loadDataSystem({ id, deliveryConfigCount: DELIVERY_CONFIG_PAGE_COUNT }).then((data) => {
        this.setState({ data })
      })
    }
  }

  handleLoadNextDeliveryConfigPage = async (cursor) => {
    return (
      await api.loadDataSystem({
        id:                   this.props.match.params.id,
        deliveryConfigCount:  DELIVERY_CONFIG_PAGE_COUNT,
        deliveryConfigCursor: cursor 
      })
    ).deliveryConfigs
  }

  renderData() {
    const { history } = this.props
    const { name, description, deliveryConfigs } = this.state.data

    return (
      <div className="data-system-details">
        <DetailsHeader title={name} description={description} type={'DataSystem'} />

        <div className="delivery-configs">
          <div className="title">Delivery Configurations</div>

          <ScrollableItemList
            connection={deliveryConfigs}
            loadNextPage={this.handleLoadNextDeliveryConfigPage}
            renderNode={node => <DeliveryConfigListItem node={node} history={history} />}
          />
        </div>
      </div>
    )
  }

  render() {
    return this.state.data
      ? this.renderData()
      : <Loading />
  }
}
